export enum eRoutes {
  "/clients" = "/clients",
  "/crm" = "/crm",
  "/crm/leads" = "/crm/leads",
  "/crm/leads/new" = "/crm/leads/new",
  "/crm/leads/:id" = "/crm/leads/:id",
  "/crm/projects" = "/crm/projects",
  "/crm/projects/new" = "/crm/projects/new",
  "/crm/projects/:id" = "/crm/projects/:id",
  "/crm/projects/:id/log" = "/crm/projects/:id/log",
  "/crm/targets/sales-reps" = "/crm/targets/sales-reps",
  "/crm/targets/branches" = "/crm/targets/branches",
  "/clients/new" = "/clients/new",
  "/users" = "/users",
  "/users/new" = "/users/new",
  "/users/:id" = "/users/:id",
  "/users/:id/destroy" = "/users/:id/destroy",
  "/clients/:id/preview" = "/clients/:id/preview",
  "/accept-invite" = "/accept-invite",
  "/quote-requests" = "/quote-requests",
  "/quote-requests/new" = "/quote-requests/new",
  "/quote-requests/:id/preview" = "/quote-requests/:id/preview",
  "/quote-requests/:id/edit" = "/quote-requests/:id/edit",
  "/quote-requests/:id/modify" = "/quote-requests/:id/modify",
  "/jobs" = "/jobs",
  "/jobs/:id/preview" = "/jobs/:id/preview",
  "/jobs/:id/edit" = "/jobs/:id/edit",
  "/jobs/new" = "/jobs/new",
  "/jobs/new/quote" = "/jobs/new/quote",
  "/jobs/new/order" = "/jobs/new/order",
  "/quotes" = "/quotes",
  "/quotes/:id/preview" = "/quotes/:id/preview",
  "/quotes/:id/log" = "/quotes/:id/log",
  "/goods-receipts" = "/goods-receipts",
  "/goods-receipts/all" = "/goods-receipts/all",
  "/goods-receipts/:id" = "/goods-receipts/:id",
  "/orders/new" = "/orders/new",
  "/order-requests/new" = "/order-requests/new",
  "/order-requests/incoming" = "/order-requests/incoming",
  "/order-requests/outgoing" = "/order-requests/outgoing",
  "/order-requests/:id/edit" = "/order-requests/:id/edit",
  "/quotes/new" = "/quotes/new",
  "/orders/:id/edit" = "/orders/:id/edit",
  "/deliveries/:id/new" = "/deliveries/:id/new",
  "/invoices/:id/new" = "/invoices/:id/new",
  "/deliveries" = "/deliveries",
  "/invoices" = "/invoices",
  "/deliveries/:id/preview" = "/deliveries/:id/preview",
  "/invoices/:id/preview" = "/invoices/:id/preview",
  "/deliveries/:id/fulfillment" = "/deliveries/:id/fulfillment",
  "/invoices/:id/fulfillment" = "/invoices/:id/fulfillment",
  "/orders/:id/preview" = "/orders/:id/preview",
  "/orders/:id/log" = "/orders/:id/log",
  "/orders/:id/development" = "/orders/:id/development",
  "/order-requests/:id/preview" = "/order-requests/:id/preview",
  "/order-requests/:id/log" = "/order-requests/:id/log",
  "/purchase-orders" = "/purchase-orders",
  "/purchase-orders/group" = "/purchase-orders/group",
  "/purchase-orders/:id" = "/purchase-orders/:id",
  "/purchase-orders/:id/log" = "/purchase-orders/:id/log",
  "/purchase-orders/:id/edit" = "/purchase-orders/:id/edit",
  "/purchase-orders/new" = "/purchase-orders/new",
  "/addresses" = "/addresses",
  "/addresses/new" = "/addresses/new",
  "/addresses/:id/preview" = "/addresses/:id/preview",
  "/drivers" = "/drivers",
  "/drivers/new" = "/drivers/new",

  "/sub-customers/:id" = "/sub-customers/:id",
  "/sub-customers/:id/contacts" = "/sub-customers/:id/contacts",
  "/sub-customers/:id/quotes" = "/sub-customers/:id/quotes",
  "/sub-customers/:id/orders" = "/sub-customers/:id/orders",
  "/sub-customers/:id/history" = "/sub-customers/:id/history",

  "/customers" = "/customers",
  "/customers/new" = "/customers/new",
  "/customers/merge" = "/customers/merge",
  "/customers/:id" = "/customers/:id",
  "/customers/:id/sub-customers" = "/customers/:id/sub-customers",
  "/customers/:id/rmas" = "/customers/:id/rmas",
  "/customers/:id/statements" = "/customers/:id/statements",
  "/customers/:id/nearby" = "/customers/:id/nearby",
  "/customers/:id/communications" = "/customers/:id/communications",
  "/customers/:id/events" = "/customers/:id/events",
  "/customers/:id/support" = "/customers/:id/support",
  "/customers/:id/contacts" = "/customers/:id/contacts",
  "/customers/:id/edit" = "/customers/:id/edit",
  "/customers/:id/quotes" = "/customers/:id/quotes",
  "/customers/:id/orders" = "/customers/:id/orders",
  "/customers/:id/deliveries" = "/customers/:id/deliveries",
  "/customers/:id/addresses" = "/customers/:id/addresses",
  "/customers/:id/price-lists" = "/customers/:id/price-lists",
  "/customers/:id/price-bands/named" = "/customers/:id/price-bands/named",
  "/customers/:id/price-bands" = "/customers/:id/price-bands",
  "/customers/:id/price-overrides" = "/customers/:id/price-overrides",
  "/customers/:id/history" = "/customers/:id/history",
  "/customers/:id/products" = "/customers/:id/products",
  "/customers/:id/restricted-product-groups" = "/customers/:id/restricted-product-groups",
  "/customers/:id/product-group-discounts" = "/customers/:id/product-group-discounts",
  "/customers/:id/product-group-rebates" = "/customers/:id/product-group-rebates",
  "/customers/:id/projects" = "/customers/:id/projects",
  "/customers/:id/universal-price-bands" = "/customers/:id/universal-price-bands",
  "/customers/:id/price-enquiry" = "/customers/:id/price-enquiry",
  "/customers/:id/tags" = "/customers/:id/tags",
  "/customers/:id/memos" = "/customers/:id/memos",
  "/customers/:id/payments" = "/customers/:id/payments",
  "/customers/:id/purchased-products" = "/customers/:id/purchased-products",
  "/customers/:id/audit" = "/customers/:id/audit",
  "/suppliers" = "/stock/suppliers",
  "/suppliers/:id" = "/stock/suppliers/:id",
  "/suppliers/bulk/price-imports" = "/stock/suppliers/bulk/price-imports",
  "/suppliers/:id/price-imports" = "/stock/suppliers/:id/price-imports",
  "/suppliers/:supplierId/price-imports/:id" = "/stock/suppliers/:supplierId/price-imports/:id",
  "/suppliers/:id/import-prices" = "/stock/suppliers/:id/import-prices",
  "/suppliers/:id/edit" = "/stock/suppliers/:id/edit",
  "/suppliers/:id/addresses" = "/stock/suppliers/:id/addresses",
  "/price-imports/:id" = "/price-imports/:id",
  "/price-imports/new" = "/price-imports/new",
  "/stock/products/:id" = "/stock/products/:id",
  "/stock/products/:id/quotes" = "/stock/products/:id/quotes",
  "/stock/products/:id/quote-email" = "/stock/products/:id/quote-email",
  "/stock/products/:id/locations" = "/stock/products/:id/locations",
  "/stock/products/:id/merge" = "/stock/products/:id/merge",
  "/stock/products/:id/orders" = "/stock/products/:id/orders",
  "/stock/products/:id/edit" = "/stock/products/:id/edit",
  "/stock/products" = "/stock/products",
  "/stock" = "/stock",
  "/stock/product-groups" = "/stock/product-groups",
  "/stock/product-groups/:id" = "/stock/product-groups/:id",
  "/stock/products/new" = "/stock/products/new",
  "/stock/minimum-price-imports" = "/stock/minimum-price-imports",
  "/stock/minimum-price-imports/new" = "/stock/minimum-price-imports/new",
  "/stock/minimum-price-imports/:id" = "/stock/minimum-price-imports/:id",
  "/stock/warehouses" = "/stock/warehouses",
  "/stock/warehouses/:id" = "/stock/warehouses/:id",

  "/stock/slim-stock" = "/stock/slim-stock",
  "/stock/slim-stock/import-purchase-orders" = "/stock/slim-stock/import-purchase-orders",
  "/stock/slim-stock/purchase-orders" = "/stock/slim-stock/purchase-orders",
  "/stock/slim-stock/article-code-master" = "/stock/slim-stock/article-code-master",
  "/stock/slim-stock/article-filter" = "/stock/slim-stock/article-filter",
  "/stock/slim-stock/confirmed-demand" = "/stock/slim-stock/confirmed-demand",
  "/stock/slim-stock/historical-purchase-orders" = "/stock/slim-stock/historical-purchase-orders",
  "/stock/slim-stock/logistics" = "/stock/slim-stock/logistics",
  "/stock/slim-stock/stock" = "/stock/slim-stock/stock",

  "/stock/categories" = "/stock/categories",
  "/stock/categories/new" = "/stock/categories/new",
  "/stock/categories/:id" = "/stock/categories/:id",

  "/stock/brands" = "/stock/brands",
  "/stock/brands/:id" = "/stock/brands/:id",
  "/stock/brands/new" = "/stock/brands/new",

  "/stock/manufacturers" = "/stock/manufacturers",
  "/stock/manufacturers/:id" = "/stock/manufacturers/:id",
  "/stock/manufacturers/new" = "/stock/manufacturers/new",

  "/stock/serial-numbers" = "/stock/serial-numbers",

  "/stock/product-group-masters" = "/stock/product-group-masters",
  "/stock/product-group-masters/:id/sales-restrictions" = "/stock/product-group-masters/:id/sales-restrictions",
  "/stock/product-group-masters/:id" = "/stock/product-group-masters/:id",

  "/stock/product-master-groups" = "/stock/product-master-groups",
  "/stock/product-master-groups/new" = "/stock/product-master-groups/new",
  "/stock/product-master-groups/:id" = "/stock/product-master-groups/:id",
  "/stock/product-master-groups/:id/edit" = "/stock/product-master-groups/:id/edit",
  "/stock/product-masters" = "/stock/product-masters",
  "/stock/product-masters/:id/update-products" = "/stock/product-masters/:id/update-products",
  "/stock/product-masters/:id/edit" = "/stock/product-masters/:id/edit",
  "/stock/product-masters/:id/audit" = "/stock/product-masters/:id/audit",
  "/stock/product-masters/:id/files" = "/stock/product-masters/:id/files",
  "/stock/product-masters/:id/images" = "/stock/product-masters/:id/images",
  "/stock/product-masters/:id/products" = "/stock/product-masters/:id/products",
  "/stock/product-masters/:id/tags" = "/stock/product-masters/:id/tags",
  "/stock/product-masters/:id" = "/stock/product-masters/:id",

  "/profile/microsoft" = "/profile/microsoft",

  "/stock/products/consignment" = "/stock/products/consignment",

  "/stock/stock-takes" = "/stock/stock-takes",
  "/stock/stock-takes/export-errors" = "/stock/stock-takes/export-errors",
  "/stock/stock-takes/new" = "/stock/stock-takes/new",
  "/stock/stock-takes/import" = "/stock/stock-takes/import",
  "/stock/stock-takes/:id" = "/stock/stock-takes/:id",
  "/stock/stock-takes/:id/products" = "/stock/stock-takes/:id/products",
  "/stock/stock-takes/:id/export" = "/stock/stock-takes/:id/export",
  "/stock/stock-takes/:id/counts/:countId" = "/stock/stock-takes/:id/counts/:countId",
  "/stock/stock-takes/:id/counts/:countId/review" = "/stock/stock-takes/:id/counts/:countId/review",

  "/warehouse/pending-picks" = "/warehouse/pending-picks",
  "/warehouse/pending-picks/:id" = "/warehouse/pending-picks/:id",

  "/help" = "/help",
  "/internal-tickets" = "/internal-tickets",
  "/manage-branch" = "/manage-branch",
  "/manage-branch/edit" = "/manage-branch/edit",
  "/manage-branch/internal-users" = "/manage-branch/internal-users",
  "/manage-branch/internal-users/new" = "/manage-branch/internal-users/new",
  "/manage-branch/internal-users/:id" = "/manage-branch/internal-users/:id",
  "/super-admin" = "/super-admin",
  "/super-admin/site-banners" = "/super-admin/site-banners",
  "/system/site-banners" = "/system/site-banners",
  "/system/link-tooltips" = "/system/link-tooltips",
  "/system/preview-features" = "/system/preview-features",
  "/system/integrations/sage-auth" = "/system/integrations/sage-auth",
  "/system/integrations/postcodes" = "/system/integrations/postcodes",
  "/system/integrations/mrge" = "/system/integrations/mrge",
  "/system/integrations/sage-http-requests" = "/system/integrations/sage-http-requests",
  "/system/integrations/search-index" = "/system/integrations/search-index",
  "/system/monitoring/gr-pending-allocations" = "/system/monitoring/gr-pending-allocations",
  "/system/monitoring/file-generations" = "/system/monitoring/file-generations",
  "/system/monitoring/alerts" = "/system/monitoring/alerts",
  "/system/monitoring/notifications" = "/system/monitoring/notifications",
  "/system/monitoring/permissions-audit" = "/system/monitoring/permissions-audit",
  "/system/monitoring/database-performance" = "/system/monitoring/database-performance",
  "/system/monitoring/logs" = "/system/monitoring/logs",
  "/super-admin/goods-receipt-pending-allocations" = "/super-admin/goods-receipt-pending-allocations",
  "/super-admin/notifications" = "/super-admin/notifications",
  "/super-admin/permissions-audit" = "/super-admin/permissions-audit",
  "/super-admin/database-performance" = "/super-admin/database-performance",
  "/super-admin/mrge-requests" = "/super-admin/mrge-requests",
  "/system/alerts" = "/system/alerts",
  "/super-admin/branches" = "/super-admin/branches",
  "/super-admin/branches/new" = "/super-admin/branches/new",
  "/super-admin/sage-imports" = "/super-admin/sage-imports",
  "/super-admin/emails" = "/super-admin/emails",
  "/super-admin/design-guide" = "/super-admin/design-guide",
  "/price-imports" = "/stock/price-imports",
  "/stock/all-price-imports" = "/stock/all-price-imports",
  "/drivers/:id" = "/drivers/:id",
  "/orders" = "/orders",
  "/orders/mass-export" = "/orders/mass-export",
  "/order-requests" = "/order-requests",
  "/quotes/:id/edit" = "/quotes/:id/edit",
  "/sage-purchase-orders" = "/sage-purchase-orders",
  "/sage-purchase-orders/:id" = "/sage-purchase-orders/:id",
  "/my-account" = "/my-account",
  "/my-dashboard" = "/my-dashboard",
  "/my-account/users" = "/my-account/users",
  "/my-account/details" = "/my-account/details",
  "/notifications" = "/notifications",
  "/branch" = "/branch",
  "/branch/:id" = "/branch/:id",
  "/sage-sync" = "/sage-sync",
  "/product/:stock_code" = "/product/:stock_code",
  "/reports" = "/reports",
  "/reports/cash-sales" = "/reports/cash-sales",
  "/reports/unexported-cash-sales" = "/reports/unexported-cash-sales",
  "/reports/profit-loss" = "/reports/profit-loss",
  "/reports/aged-debtors" = "/reports/aged-debtors",
  "/reports/universal-orders" = "/reports/universal-orders",
  "/reports/aged-creditors" = "/reports/aged-creditors",
  "/reports/project-registration" = "/reports/project-registration",
  "/reports/support-tickets/user" = "/reports/support-tickets/user",
  "/reports/support-tickets/type" = "/reports/support-tickets/type",
  "/reports/branch-stock-value" = "/reports/branch-stock-value",
  "/reports/grn-stock" = "/reports/grn-stock",
  "/reports/daily-sales" = "/reports/daily-sales",
  "/reports/daily-sales/ireland" = "/reports/daily-sales/ireland",
  "/reports/absent-users" = "/reports/absent-users",
  "/reports/outstanding-or-products" = "/reports/outstanding-or-products",
  "/reports/stock-value" = "/reports/stock-value",
  "/reports/margin-by-customer" = "/reports/margin-by-customer",
  "/reports/realised-margin-by-customer" = "/reports/realised-margin-by-customer",
  "/reports/margin-by-supplier" = "/reports/margin-by-supplier",
  "/reports/realised-margin-by-supplier" = "/reports/realised-margin-by-supplier",
  "/reports/margin-by-category" = "/reports/margin-by-category",
  "/reports/realised-margin-by-category" = "/reports/realised-margin-by-category",
  "/reports/margin-by-product-group" = "/reports/margin-by-product-group",
  "/reports/branch-summary" = "/reports/branch-summary",
  "/reports/margin-by-product-code" = "/reports/margin-by-product-code",
  "/reports/realised-margin-by-product-code" = "/reports/realised-margin-by-product-code",
  "/reports/realised-margin-by-product-group" = "/reports/realised-margin-by-product-group",
  "/reports/margin-threshold" = "/reports/margin-threshold",
  "/reports/average-margin" = "/reports/average-margin",
  "/reports/sales-rep-margin" = "/reports/sales-rep-margin",
  "/reports/realised-margin-by-sales-rep" = "/reports/realised-margin-by-sales-rep",
  "/reports/variance-report-branch" = "/reports/variance-report-branch",
  "/reports/variance-report-user" = "/reports/variance-report-user",
  "/reports/variance-report-customer" = "/reports/variance-report-customer",
  "/reports/sales-allocation-report" = "/reports/sales-allocation-report",
  "/reports/branch" = "/reports/branch",
  "/reports/delivery-method" = "/reports/delivery-method",
  "/reports/branch-monthly" = "/reports/branch-monthly",
  "/reports/sales" = "/reports/sales",
  "/reports/sales-monthly" = "/reports/sales-monthly",
  "/reports/unallocated-order-items" = "/reports/unallocated-order-items",
  "/reports/aged-stock-report" = "/reports/aged-stock-report",
  "/reports/stock-cover" = "/reports/stock-cover",
  "/reports/stock-cover-by-product" = "/reports/stock-cover-by-product",
  "/reports/builder" = "/reports/builder",
  "/stock/supplier-masters/:id" = "/stock/supplier-masters/:id",
  "/stock/supplier-masters/new" = "/stock/supplier-masters/new",
  "/stock/supplier-masters" = "/stock/supplier-masters",
  "/system" = "/system",
  "/system/feedback" = "/system/feedback",
  "/system/customer-slideshow" = "/system/customer-slideshow",
  "/system/customer-slideshow/new" = "/system/customer-slideshow/new",
  "/system/customer-slideshow/reorder" = "/system/customer-slideshow/reorder",
  "/system/customer-slideshow/:id" = "/system/customer-slideshow/:id",
  "/system/users" = "/system/users",
  "/system/videos" = "/system/videos",
  "/system/reports-events" = "/system/reports-events",
  "/system/roles" = "/system/roles",
  "/system/roles/new" = "/system/roles/new",
  "/system/roles/:id" = "/system/roles/:id",
  "/system/roles/:id/users" = "/system/roles/:id/users",
  "/customer-support/return-requests" = "/customer-support/return-requests",
  "/customer-support/return-requests/:id" = "/customer-support/return-requests/:id",
  "/customer-support/trade-applications" = "/customer-support/trade-applications",
  "/customer-support/trade-applications/:id" = "/customer-support/trade-applications/:id",
  "/customer-support/pending-accounts" = "/customer-support/pending-accounts",
  "/customer-support/pending-accounts/:id" = "/customer-support/pending-accounts/:id",
  "/customer-support/stats" = "/customer-support/stats",
  "/customer-support/spending" = "/customer-support/spending",
  "/crm/sales-reps/assignments" = "/crm/sales-reps/assignments",
  "/crm/customer-lists" = "/crm/customer-lists",
  "/crm/tags" = "/crm/tags",
  "/crm/tags/new" = "/crm/tags/new",
  "/crm/tags/:id" = "/crm/tags/:id",

  "/stock/tags" = "/stock/tags",
  "/stock/tags/new" = "/stock/tags/new",
  "/stock/tags/import" = "/stock/tags/import",
  "/stock/tags/:id" = "/stock/tags/:id",

  "/system/users/:id" = "/system/users/:id",
  "/system/finance/invoice-adjustments" = "/system/finance/invoice-adjustments",
  "/system/finance/invoice-adjustments/new" = "/system/finance/invoice-adjustments/new",
  "/system/finance/invoice-adjustments/:id" = "/system/finance/invoice-adjustments/:id",
  "/change-log" = "/change-log",
  "/stock/lines-of-business" = "/stock/lines-of-business",
  "/stock/lines-of-business/:id" = "/stock/lines-of-business/:id",
  "/stock/lines-of-business/new" = "/stock/lines-of-business/new",
  "/stock/product-master-importer" = "/stock/product-master-importer",
  "/stock/stock-transfers" = "/stock/stock-transfers",
  "/stock/stock-transfers/new" = "/stock/stock-transfers/new",
  "/stock/stock-transfers/:id" = "/stock/stock-transfers/:id",
  "/stock/stock-transfers/:id/edit" = "/stock/stock-transfers/:id/edit",

  "/crm/customers" = "/crm/customers",
  "/crm/customers/unlinked" = "/crm/customers/unlinked",
  "/crm/customers/sales-reps" = "/crm/customers/sales-reps",

  "/crm/sales-reps" = "/crm/sales-reps",
  "/crm/sales-reps/new" = "/crm/sales-reps/new",
  "/crm/sales-reps/:id" = "/crm/sales-reps/:id",
  "/crm/sales-reps/:id/customers" = "/crm/sales-reps/:id/customers",
  "/crm/sales-reps/:id/orders" = "/crm/sales-reps/:id/orders",
  "/crm/sales-reps/:id/quotes" = "/crm/sales-reps/:id/quotes",
  "/crm/sales-reps/:id/edit" = "/crm/sales-reps/:id/edit",
  "/crm/sales-reps/:id/tasks" = "/crm/sales-reps/:id/tasks",
  "/crm/sales-reps/:id/events" = "/crm/sales-reps/:id/events",
  "/crm/sales-reps/:id/emails" = "/crm/sales-reps/:id/emails",
  "/crm/sales-reps/:id/invoice-migrate" = "/crm/sales-reps/:id/invoice-migrate",

  "/customer-support" = "/customer-support",
  "/customer-support/support-tickets" = "/customer-support/support-tickets",
  "/customer-support/support-tickets/new" = "/customer-support/support-tickets/new",
  "/customer-support/support-tickets/:id" = "/customer-support/support-tickets/:id",
  "/customer-support/support-tickets/:id/history" = "/customer-support/support-tickets/:id/history",
  "/customer-support/settings" = "/customer-support/settings",
  "/customer-support/groups" = "/customer-support/groups",

  "/stock/price-bands" = "/stock/price-bands",
  "/stock/price-bands/new" = "/stock/price-bands/new",
  "/stock/price-bands/:id" = "/stock/price-bands/:id",
  "/stock/price-bands/:id/customers" = "/stock/price-bands/:id/customers",
  "/stock/price-bands/:id/imports" = "/stock/price-bands/:id/imports",
  "/stock/price-bands/:id/imports/new" = "/stock/price-bands/:id/imports/new",
  "/stock/price-bands/:id/edit" = "/stock/price-bands/:id/edit",
  "/stock/price-bands/:id/audit" = "/stock/price-bands/:id/audit",
  "/stock/price-bands/:id/log" = "/stock/price-bands/:id/log",

  "/stock/shared-price-bands" = "/stock/shared-price-bands",
  "/stock/shared-price-bands/new" = "/stock/shared-price-bands/new",
  "/stock/shared-price-bands/import/:id" = "/stock/shared-price-bands/import/:id",
  "/stock/shared-price-bands/:id" = "/stock/shared-price-bands/:id",
  "/stock/shared-price-bands/:id/customers" = "/stock/shared-price-bands/:id/customers",
  "/stock/shared-price-bands/:id/edit" = "/stock/shared-price-bands/:id/edit",
  "/stock/shared-price-bands/:id/imports" = "/stock/shared-price-bands/:id/imports",

  "/stock/universal-price-bands" = "/stock/universal-price-bands",
  "/stock/universal-price-bands/:id" = "/stock/universal-price-bands/:id",
  "/stock/universal-price-bands/:id/customers" = "/stock/universal-price-bands/:id/customers",
  "/stock/universal-price-bands/:id/edit" = "/stock/universal-price-bands/:id/edit",
  "/stock/universal-price-bands/:id/imports" = "/stock/universal-price-bands/:id/imports",
  "/stock/universal-price-bands/new" = "/stock/universal-price-bands/new",
  "/stock/universal-price-bands/import/:id" = "/stock/universal-price-bands/import/:id",

  "/crm/bulk-email/new" = "/crm/bulk-email/new",
  "/crm/bulk-email/:id" = "/crm/bulk-email/:id",
  "/crm/bulk-email/:id/edit" = "/crm/bulk-email/:id/edit",
  "/crm/bulk-email" = "/crm/bulk-email",
  "/crm/tasks" = "/crm/tasks",

  "/system/sage-exports" = "/system/sage-exports",
  "/system/sage-exports/orders" = "/system/sage-exports/orders",
  "/system/sage-exports/product-group-discounts" = "/system/sage-exports/product-group-discounts",
  "/system/sage-exports/purchase-orders" = "/system/sage-exports/purchase-orders",
  "/system/sage-exports/customers" = "/system/sage-exports/customers",
  "/system/sage-exports/stock-transfers" = "/system/sage-exports/stock-transfers",
  "/system/sage-exports/stock-takes" = "/system/sage-exports/stock-takes",
  "/system/sage-exports/price-imports" = "/system/sage-exports/price-imports",
  "/system/sage-exports/price-export-queue" = "/system/sage-exports/price-export-queue",

  "/hr" = "/hr",

  "/hr/teams" = "/hr/teams",
  "/hr/teams/new" = "/hr/teams/new",
  "/hr/teams/:id" = "/hr/teams/:id",
  "/hr/teams/:id/users" = "/hr/teams/:id/users",

  "/hr/probation-review" = "/hr/probation-review",
  "/hr/calendar-dates" = "/hr/calendar-dates",
  "/hr/requests" = "/hr/requests",
  "/hr/requests/new" = "/hr/requests/new",
  "/hr/requests/:id" = "/hr/requests/:id",
  "/hr/requests/:id/edit" = "/hr/requests/:id/edit",

  "/hr/holiday-requests" = "/hr/holiday-requests",
  "/hr/absence-requests" = "/hr/absence-requests",
  "/hr/holiday-requests/new" = "/hr/holiday-requests/new",
  "/hr/absence-requests/new" = "/hr/absence-requests/new",

  "/hr/requests/holiday" = "/hr/requests/holiday",
  "/hr/requests/absence" = "/hr/requests/absence",
  "/hr/requests/holiday/new" = "/hr/requests/holiday/new",
  "/hr/requests/absence/new" = "/hr/requests/absence/new",

  "/hr/manage-requests/new" = "/hr/manage-requests/new",
  "/hr/manage-requests/:id" = "/hr/manage-requests/:id",
  "/hr/manage-requests/:id/edit" = "/hr/manage-requests/:id/edit",

  "/hr/staff-changes" = "/hr/staff-changes",
  "/hr/staff-changes/new" = "/hr/staff-changes/new",
  "/hr/staff-changes/:id" = "/hr/staff-changes/:id",

  "/statements" = "/statements",

  "/forgot-password" = "/forgot-password",
  "/cart" = "/cart",
  "/products" = "/products",
  "/deals" = "/deals",
  "/deals-sign-in" = "/deals-sign-in",
  "/brands" = "/brands",

  "/sign-in" = "/sign-in",
  "/sign-up" = "/sign-up",
  "/terms-and-conditions" = "/terms-and-conditions",
  "/privacy-policy" = "/privacy-policy",
  "/support-and-returns" = "/support-and-returns",
  "/support-and-returns/ireland" = "/support-and-returns/ireland",
  "/support-and-returns/uk" = "/support-and-returns/uk",
  "/support-and-returns/customer-support/rma" = "/support-and-returns/customer-support/rma",
  "/return-requests" = "/return-requests",
  "/return-requests/:id" = "/return-requests/:id",
  "/application" = "/application",

  "/customer-support/rma" = "/customer-support/rma",
  "/customer-support/rma/new" = "/customer-support/rma/new",
  "/customer-support/rma/:id" = "/customer-support/rma/:id",
  "/customer-support/rma/:id/history" = "/customer-support/rma/:id/history",

  "/stock/universal-price-lists" = "/stock/universal-price-lists",
  "/stock/buying-groups" = "/stock/buying-groups",
  "/stock/buying-groups/new" = "/stock/buying-groups/new",
  "/stock/buying-groups/:id" = "/stock/buying-groups/:id",
  "/stock/buying-groups/:id/customers" = "/stock/buying-groups/:id/customers",
  "/stock/buying-groups/:id/price-bands" = "/stock/buying-groups/:id/price-bands",
  "/stock/buying-groups/:id/rebates" = "/stock/buying-groups/:id/rebates",

  "/rma" = "/rma",
  "/rma/new" = "/rma/new",
  "/rma/:id" = "/rma/:id",
  "/rma/:id/edit" = "/rma/:id/edit",
  "/favourites" = "/favourites",
  "/favourites/:groupId" = "/favourites/:groupId",
  "/checkout" = "/checkout",

  "/stock/kits" = "/stock/kits",
  "/stock/kits/new" = "/stock/kits/new",
  "/stock/kits/:id" = "/stock/kits/:id",

  "/stock/bom-items" = "/stock/bom-items",
  "/stock/bom-items/new" = "/stock/bom-items/new",
  "/stock/bom-items/:id" = "/stock/bom-items/:id",

  "/system/file-generations" = "/system/file-generations",

  "/category/:idOrSlug" = "/category/:idOrSlug",

  "/customer-support/customer-page-banners" = "/customer-support/customer-page-banners",
  "/customer-support/customer-page-banners/new" = "/customer-support/customer-page-banners/new",
  "/customer-support/customer-page-banners/:id" = "/customer-support/customer-page-banners/:id",
}

export function buildRoute(
  route: eRoutes,
  params: Record<string, any>,
  opts: { qs?: Record<string, string> } = {},
) {
  let str: string = route

  if (!str) {
    return ""
  }

  for (const key in params) {
    str = str.replace(`:${key}`, params[key])
  }

  if (opts.qs) {
    const queryString = new URLSearchParams(opts.qs).toString()
    str += `?${queryString}`
  }

  return str
}

// eslint-disable-next-line prettier/prettier
export type IERoute = keyof typeof eRoutes
